__turbopack_context__.v({
  "autoSizedItem": "LsmDza_autoSizedItem",
  "backButton": "LsmDza_backButton",
  "button": "LsmDza_button",
  "forwardButton": "LsmDza_forwardButton",
  "grelf": "LsmDza_grelf",
  "grid": "LsmDza_grid",
  "gridByColumnCount": "LsmDza_gridByColumnCount",
  "gridByColumnWidth": "LsmDza_gridByColumnWidth",
  "gridClampedWidth": "LsmDza_gridClampedWidth",
  "gridEvenColumns": "LsmDza_gridEvenColumns",
  "itemCollection": "LsmDza_itemCollection",
  "itemWrapper": "LsmDza_itemWrapper",
  "itemsContainer": "LsmDza_itemsContainer",
  "shelf": "LsmDza_shelf",
  "shelfClampedWidth": "LsmDza_shelfClampedWidth",
});
